import { ColumnType } from "antd/es/table/interface";
import { CheckboxValueType } from "antd/lib/checkbox/Group";

export function useFilterColumns(
  columns: any[],
  checkedValue: CheckboxValueType[]
) {
  const newColumns = columns.filter((c: ColumnType<any>) => {
    return (
      (c.key || c.dataIndex) === "operation" ||
      checkedValue.includes((c.key || c.dataIndex) as string)
    );
  });

  return { columns: newColumns };
}
